import {mapState} from "vuex";

const scrollTo = {
    data() {
        return {
            scrollOptions: {
                container: 'body',
                easing: null,
                duration: -1,
                offset: -60,
                force: false,
                cancelable: true,
                x: false,
                y: true
            }
        };
    },

    computed: {
        ...mapState({
            scrolledItem: state => state.scrolledItem
        })
    }
};

export default scrollTo;
